export const iconStyle = {
    color: '#41ad72',
    '&:hover': {
        backgroundColor: '#e85a2c',
    },
};